import { useMutation, useQueryClient } from '@tanstack/react-query'
import { meKey } from '@/features/auth/api'
import { http } from '@/lib/api/client'
import type { Resource, Staff } from '@/lib/api/types'

export function useUpdateName() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (name: string) => (await http.patch<Resource<Staff>>('/me/profile', { name })).data,
    onSuccess: (staff) => queryClient.setQueryData(meKey, staff),
  })
}

export interface PasswordChange {
  current_password: string
  password: string
  password_confirmation: string
}

export function useChangePassword() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (input: PasswordChange) =>
      (await http.put<Resource<Staff>>('/me/password', input)).data,
    onSuccess: (staff) => queryClient.setQueryData(meKey, staff),
  })
}
